// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preLoadPage[data-v-f86c4072]{background:rgba(189,195,199,.25);background:linear-gradient(90deg,rgba(44,62,80,.14),rgba(189,195,199,.26))}.loadingPage[data-v-f86c4072]{height:100vh;display:flex;align-items:center;justify-content:center;background:url(https://i.postimg.cc/nz4bCmFt/main-spinner.gif) no-repeat 50% fixed}", ""]);
// Exports
module.exports = exports;
